import type { ChatAnalyticsEvent } from "@hopper-ai/chat-widget";

export interface HtsAssistRBCEvent {
  eventName: string;
  properties?: Record<string, unknown>;
}

/**
 * Maps a normalized chat-widget analytics event to the RBC product-analytics
 * event it should publish, or null for events RBC does not track. Event names
 * follow RBC's tap-detection convention (see rbcAnalytics.ts).
 */
export const mapHtsAssistAnalyticsEvent = (
  event: ChatAnalyticsEvent
): HtsAssistRBCEvent | null => {
  switch (event.type) {
    case "widget_opened":
      return { eventName: "tapped_assist_widget" };
    case "widget_minimized":
      return { eventName: "minimized_assist_widget" };
    case "widget_closed":
      return { eventName: "closed_assist_widget" };
    case "composer_submitted":
      return { eventName: "sent_assist_message" };
    case "a2ui_action":
      return {
        eventName: "tapped_assist_action",
        properties: { action: event.actionName },
      };
    default:
      return null;
  }
};
